import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormGroup, ControlLabel, Collapse } from 'react-bootstrap';
import moment from 'moment';
import { find, delay, first } from 'lodash';
import DatePicker from 'react-datepicker';
import Fa from 'react-fontawesome';
import DateTimeDisplay from '../../../../components/date-time-display';
import formStyles from '../../../../components/search-form/styles.css';
import styles from './styles.css';

const OPTIONS = [
  { label: 'Last Week', value: 'last-week' },
  { label: 'Last Month', value: 'last-month', isDefault: true },
  { label: 'Last Quarter', value: 'last-quarter' },
];

export function convertPipeline(pipelineSince) {
  let m = null;
  // FRIDAY! not SATURDAY
  if (pipelineSince === 'last-week') {
    m = moment().subtract(1, 'weeks').endOf('week').subtract(1, 'days');
  } else if (pipelineSince === 'last-month') {
    m = moment().subtract(1, 'month').endOf('month');
  } else if (pipelineSince === 'last-quarter') {
    m = moment().subtract(1, 'quarter').endOf('quarter');
  } else {
    m = moment(pipelineSince, 'YYYY-MM-DD');
  }
  if (m && m.isValid()) {
    return m;
  }
  return null;
}

class PipelineDateDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openCalendar: false,
      selectedDate: null,
    };
    delay(() => {
      this.checkProps(props, true);
    }, 100);
    this.setPeriod = this.setPeriod.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.checkProps(nextProps);
  }

  setPeriod(option) {
    const { value } = option;
    if (value) {
      this.props.onUpdate(option);
      this.setState({ open: false, openCalendar: false });
    } else {
      this.setState({ openCalendar: true });
    }
  }

  handleDateChange(date) {
    const m = moment(date);
    let value = m.format('YYYY-MM-DD');
    const lastWeek = moment().subtract(1, 'weeks').endOf('week').subtract(1, 'days'); // friday!
    const lastMonth = moment().subtract(1, 'months').endOf('month');
    const lastQuarter = moment().subtract(1, 'quarters').endOf('quarter');
    if (m.isSame(lastWeek, 'day')) {
      value = 'last-week';
    } else if (m.isSame(lastMonth, 'day')) {
      value = 'last-month';
    } else if (m.isSame(lastQuarter, 'day')) {
      value = 'last-quarter';
    }
    this.setPeriod({ value });
  }

  checkProps(props, force = false) {
    const { pipelineSince } = props;
    if (pipelineSince !== this.props.pipelineSince || force) {
      const m = convertPipeline(pipelineSince);
      if (m && m.isValid()) {
        this.setState({ selectedDate: m });
      } else {
        const defaultOption = find(OPTIONS, { isDefault: true }) || first(OPTIONS);
        if (defaultOption) {
          const m2 = convertPipeline(defaultOption.value);
          if (m2 && m2.isValid()) {
            this.setState({ selectedDate: m2 });
          }
        }
      }
    }
  }

  render() {
    const { pipelineSince } = this.props;
    const { selectedDate } = this.state;
    const options = OPTIONS;
    const selectedOption = find(options, { value: pipelineSince });

    const displayLabels = [];
    if (selectedOption && selectedDate && selectedDate.isValid) {
      displayLabels.push(<span key={1}>{selectedOption.label}</span>);
      displayLabels.push(<span key={2}>&nbsp;(<DateTimeDisplay value={selectedDate} format="short" />)</span>);
    } else if (selectedOption) {
      displayLabels.push(<span key={1}>{selectedOption.label}</span>);
    } else if (selectedDate && selectedDate.isValid) {
      displayLabels.push(<DateTimeDisplay key={1} value={selectedDate} format="short" />);
    }

    const displayLabel = displayLabels.length > 0 ? displayLabels : 'Period';
    const borderStyle = { borderColor: '#009688' };
    return (
      <div style={borderStyle} className={formStyles.field}>
        <FormGroup>
          <div className="row">
            <div className="col-sm-4 col-md-3">
              <ControlLabel>Pipeline Since</ControlLabel>
            </div>
            <div className="col-sm-8 col-md-9">
              <a
                href=""
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.setState({ open: !this.state.open });
                }}
              >
                {displayLabel}
              </a>
              <Collapse in={this.state.open}>
                <div className={`panel panel-default ${formStyles.dateRangePanel}`}>
                  <div className="panel-body">
                    <Collapse in={!this.state.openCalendar}>
                      <div>
                        <div className={styles.list}>
                          {options.map((option) => {
                            const isActive = selectedOption && selectedOption.value === option.value;
                            return (
                              <label
                                key={option.value}
                                className={`${isActive ? styles.active : null} checkbox`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.setPeriod(option);
                                }}
                              >
                                <Fa name={isActive ? 'check-circle' : 'circle-o'} className={isActive ? 'text-active' : 'text-muted'} /> {option.label}
                              </label>
                            );
                          })}
                        </div>
                        <p />
                        <div>
                          Or&nbsp;
                          <a
                            href=""
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              this.setPeriod({ value: null });
                            }}
                          >
                            pick a custom date <Fa name="calendar-o" />
                          </a>
                        </div>
                      </div>
                    </Collapse>
                    <Collapse in={this.state.openCalendar}>
                      <div>
                        <a
                          href=""
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.setState({ openCalendar: false });
                          }}
                        >
                          <Fa name="chevron-left" /> Back
                        </a>
                        <div>
                          {this.state.openCalendar && <DatePicker
                            dateFormat="DD MMM YYYY"
                            className="form-control clickable"
                            showYearDropdown
                            selected={selectedDate && selectedDate.isValid() ? selectedDate : null}
                            scrollableYearDropdown
                            inline
                            onChange={this.handleDateChange}
                          />}
                        </div>
                      </div>
                    </Collapse>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </FormGroup>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

PipelineDateDropdown.propTypes = {
  pipelineSince: PropTypes.string.isRequired,
  onUpdate: PropTypes.func,
};

PipelineDateDropdown.defaultProps = {
  onUpdate: () => {},
};
PipelineDateDropdown.contextTypes = {
};

export default connect(mapStateToProps)(PipelineDateDropdown);
